import { ReferenceLine } from "recharts";
import {
    formatCostLabel,
    LABEL_FONT_SIZE,
    REFERENCE_LINE_COLOR,
    STROKE_DASH_ARRAY,
    STROKE_WIDTH
} from "./costGraphsSectionHelpers";

type CostReferenceLinesProps = {
    readonly showPerMW: boolean;
    readonly costAtProjectSize?: number;
    readonly costPerMWAtProjectSize?: number;
    readonly projectSize?: number;
};

export const CostReferenceLines: React.FC<CostReferenceLinesProps> = ({
    showPerMW,
    costAtProjectSize,
    costPerMWAtProjectSize,
    projectSize
}) => {
    if (projectSize === undefined) {
        return null;
    }

    const showYReference =
        (showPerMW && costPerMWAtProjectSize !== undefined) ||
        (!showPerMW && costAtProjectSize !== undefined);

    const yValue = showPerMW ? costPerMWAtProjectSize : costAtProjectSize;
    const yLabelValue = formatCostLabel(
        showPerMW,
        projectSize,
        costPerMWAtProjectSize,
        costAtProjectSize
    );

    return (
        <>
            {showYReference && (
                <ReferenceLine
                    y={yValue}
                    stroke={REFERENCE_LINE_COLOR}
                    strokeDasharray={STROKE_DASH_ARRAY}
                    strokeWidth={STROKE_WIDTH}
                    label={{
                        value: yLabelValue,
                        position: "insideBottomRight",
                        fill: REFERENCE_LINE_COLOR,
                        fontSize: LABEL_FONT_SIZE
                    }}
                />
            )}
            <ReferenceLine
                x={projectSize}
                stroke={REFERENCE_LINE_COLOR}
                strokeDasharray={STROKE_DASH_ARRAY}
                strokeWidth={STROKE_WIDTH}
                label={{
                    value: `Project Size: ${projectSize}MW`,
                    position: "insideTopLeft",
                    fill: REFERENCE_LINE_COLOR,
                    fontSize: LABEL_FONT_SIZE
                }}
            />
        </>
    );
};
